import { apiClient } from './client';

export interface FinancialCapacity {
  funding_sources: string | null; accounting_system: string | null; has_finance_procedures: number; has_segregation_of_duties: number;
  has_budgeting_process: number; has_bank_reconciliation: number; has_financial_reporting: number; has_external_audit: number;
  last_audit_date: string | null; has_asset_management: number; has_fraud_controls: number; notes: string | null;
}
export interface SafeguardingAssessment {
  has_policy: number; has_focal_point: number; focal_point_name: string | null; has_reporting_mechanism: number; has_training: number;
  has_code_of_conduct: number; has_recruitment_screening: number; has_complaints_mechanism: number; has_investigation_procedure: number;
  is_survivor_centred: number; covers_child_safeguarding: number; covers_gbv: number; covers_sexual_harassment: number; covers_exploitation_abuse: number; notes: string | null;
}
export interface PartnerPolicy { policy_type: string; status: string; notes: string | null; }

export const partnerFinancialCapacityApi = {
  get: (partnerId: number) => apiClient.get<{ data: FinancialCapacity | null }>(`/api/partners/${partnerId}/financial-capacity`),
  upsert: (partnerId: number, input: object) => apiClient.put<{ data: { partnerId: number } }>(`/api/partners/${partnerId}/financial-capacity`, input),
};
export const partnerSafeguardingApi = {
  get: (partnerId: number) => apiClient.get<{ data: SafeguardingAssessment | null }>(`/api/partners/${partnerId}/safeguarding-assessment`),
  upsert: (partnerId: number, input: object) => apiClient.put<{ data: { partnerId: number } }>(`/api/partners/${partnerId}/safeguarding-assessment`, input),
};
export const partnerPoliciesApi = {
  list: (partnerId: number) => apiClient.get<{ data: PartnerPolicy[] }>(`/api/partners/${partnerId}/policies`),
  setStatus: (partnerId: number, input: { policyType: string; status: string; notes?: string }) => apiClient.put<{ data: { partnerId: number } }>(`/api/partners/${partnerId}/policies`, input),
};
